import React, { useState, useRef, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import styles from "./styles/ContestPage.module.css";
import back from "../assests/back.svg";
import forward from "../assests/forward.svg";
import * as _ from "lodash";
import Bluearrow from "../assests/blueArrow.png";
import Star from "../assests/Star.png";
import { useUserAuth } from "../context/UserAuthContext";
import Context from "../context/Context";
import axios from "axios";
import Header from "../Components/Header/Header";
import AudioElement from "../Components/AudioElement/AudioElement";
import Dance from "../Components/Campaign/Dance";
import Movie from "../Components/Campaign/Movie";
import Hotel from "../Components/Campaign/Hotel";
import Fifa from "../Components/Campaign/Fifa";
import Banner from "../Components/Banner";
import CountDown from "../Components/CountDown/CountDown";
import Accordian from "../Components/Accordian/Accordian";
import ShareInContest from "../Components/ShareInContest/ShareInContest";
import Winners from "../Components/Winnners/Winners";
import AudioPlayer from "../Components/AudioPlayer/AudioPlayer";
import ReferenceVideoPlayer from "../Components/ReferenceVideoPlayer/ReferenceVideoPlayer";
import howToParticipateIcon from "../assests/howToParticipate.svg";
import howToParticipatePlay from "../assests/howToParticipatePlay.svg";
import SingleVideoPlayer from "../Components/SingleVideoPlayer/SingleVideoPlayer";
import ContestClosePopup from "../Components/ContestClosePopup/ContestClosePopup";
// import { BsFillPlayCircleFill, BsFillPauseCircleFill } from "react-icons/bs";
import whatsappIcon from "../assests/profile/whatsappIcon.svg";

import conOpen from "../assests/conOpen.svg";
import conClosed from "../assests/conClosed.svg";
import conWinner from "../assests/conWinner.svg";

import HelpVIdeoCard from "../Components/HelpVIdeoCard/HelpVIdeoCard";
import RulesBox from "../Components/RulesBox/RulesBox";
import giftIcon from "../assests/giftIcon.svg";
import worksIcon from "../assests/worksIcon.svg";
import stepsIcon from "../assests/stepsIcon.svg";
import rulesIcon from "../assests/rulesIcon.svg";
import comingSoon from "../assests/comingSoon.svg";
import HelpingHand from "../Components/HelpingHand/HelpingHand";

const Contest = ({
  setParticipate,
  showSponsors,
  contestDetails,
  setSponserDetails,
  setContestClosed,
  contestClosed,
  handleParticipate,
  isPlaying,
  setIsplaying,
  audioElem,
  participateLoading,
  handleSignup,
  setContestParticipationTimeOut,
  contestParticipationTimeOut,
}) => {
  const navigate = useNavigate();
  const {
    campaignClosed,
    campaignType,
    campaignEntryClosed,
    details,
    setFilterState,
    conductedBy,
    preview,
    handleUserTracking,
    isMobile,
  } = useContext(Context);
  const [showFullText, setShowFullText] = useState(false);
  const [showFullPrize, setShowFullPrize] = useState(false);
  const { setPreviousLocation, currentUser, guestModeEnabled } = useUserAuth();
  const organizerName_fromURL = window.location.href.split("/")[3];
  const campaignName_fromURL = window.location.href.split("/")[4];
  const [contestClosedPopup, setContestClosedPopup] = useState(false);
  const [contestUpcomingPopup, setContestUpcomingPopup] = useState(false);
  const [contestOpenTimeout, setContestOpenTimout] = useState();
  // const [contestClosed, setContestClosed] = useState(false);
  const [winningArray, setWinningArray] = useState([]);
  const handleNavigate = () => {
    navigate(`/${organizerName_fromURL}/${campaignName_fromURL}`);
    // setFilterState(contestDetails?.contestType);
    setFilterState(
      _.isEmpty(details?.filterChips) ? "ALL" : contestDetails?.contestType
    );
  };

  const contestStatus = contestDetails?.contestStatus;

  const viewMore = () => {
    setShowFullText((prev) => !prev);
  };
  useEffect(() => {
    if (contestStatus === "CLOSED") {
      setContestClosed(true);
    }
  }, [contestStatus]);

  const howToParticipate = () => {
    if (campaignType == "DA_PAID" || campaignType == "MOV") {
      setIsplaying(false);
      audioElem.current.pause();
    }
    setParticipate(true);
  };
  const handleSponsors = (sponser) => {
    if (campaignType == "DA_PAID" || campaignType == "MOV") {
      setIsplaying(false);
      audioElem.current.pause();
    }
    setSponserDetails(sponser);
    showSponsors(true);
  };
  var prevScrollpos = window.pageYOffset;
  window.onscroll = function () {
    if (conductedBy?.logo != "") {
      var currentScrollPos = window.pageYOffset;
      if (document.getElementById("navbar")) {
        if (prevScrollpos > currentScrollPos) {
          document.getElementById("navbar").style.top = 90 + "px";
        } else {
          document.getElementById("navbar").style.top = "0px";
        }
      }
      prevScrollpos = currentScrollPos;
    }
  };
  const startDate = new Date(contestDetails?.startDate);
  const endDate = new Date(contestDetails?.endDate);
  const judgementCompleteDate = new Date(contestDetails?.judgementCompleteDate);
  const winnerAnounceDate = new Date(contestDetails?.winnerAnounceDate);

  const formattedEndDate = `${endDate.toLocaleString("default", {
    month: "long",
  })} ${endDate.getUTCDate()} ${endDate.getUTCFullYear()}  ${endDate.toLocaleTimeString()}`;

  const formattedStartDate = contestDetails?.startDate
    ? `${startDate.toLocaleString("default", {
        month: "long",
      })} ${startDate.getUTCDate()} ${startDate.getUTCFullYear()} `
    : "";

  const formattedjudgementStartDate = contestDetails?.endDate
    ? `${endDate.toLocaleString("default", {
        month: "long",
      })} ${endDate.getUTCDate()} ${endDate.getUTCFullYear()} `
    : "";

  const formattedjudgementCompleteDate = contestDetails?.judgementCompleteDate
    ? `${judgementCompleteDate.toLocaleString("default", {
        month: "long",
      })} ${judgementCompleteDate.getUTCDate()} ${judgementCompleteDate.getUTCFullYear()} `
    : "";

  const formattedwinnerAnounceDate = contestDetails?.winnerAnounceDate
    ? `${winnerAnounceDate.toLocaleString("default", {
        month: "long",
      })} ${winnerAnounceDate.getUTCDate()} ${winnerAnounceDate.getUTCFullYear()} `
    : "";

  var cardColour = contestDetails?.participateBtnClr;
  const rgbaColor = `rgba(${parseInt(cardColour?.slice(1, 3), 16)}, ${parseInt(
    cardColour?.slice(3, 5),
    16
  )}, ${parseInt(cardColour?.slice(5, 7), 16)}, 0.6)`;
  const participateButtonStyle = {
    backgroundColor: contestDetails?.participateBtnClr,
    filter: `drop-shadow(4px 4px 0px ${rgbaColor})`,
  };
  const getDetailsViaWhatsappButton = {
    backgroundColor: "#075e54",
    filter: `drop-shadow(4px 4px 0px #075e54)`,
    color: "white",
  };

  const sentDetailsToWhatsapp = () => {
    let message = `Hello GoViral Team, Could you please share Me the contest details
Contest ID : ${contestDetails?.orgDomain}/${contestDetails?.campaignUniqueText}/${contestDetails?.contestUniqueText}`;
    let phoneNumber = "+918618406454";
    const encodedContent = encodeURIComponent(message);
    const isMobileDevice = /Android|iPhone|iPad|iPod/i.test(
      navigator.userAgent
    );

    if (isMobileDevice) {
      const url = `https://wa.me/${phoneNumber}?text=${encodedContent}`;
      window.open(url, "_blank");
    } else {
      const url = `https://web.whatsapp.com/send?phone=${phoneNumber}&text=${encodedContent}`;
      window.open(url, "_blank");
    }
  };
  const boxCount = [
    !_.isEmpty(details?.howToParticipate?.description),
    !_.isEmpty(contestDetails?.howItsWorks),
    !_.isEmpty(contestDetails?.contestRules),
    details?.certificate ||
      (contestDetails?.priceDescription &&
        contestDetails?.priceDescription !== "<p></p>") ||
      !_.isEmpty(contestDetails?.prizeObj),
  ].filter(Boolean).length;

  const getGridTemplate = (count) => {
    return `repeat(${count}, minmax(0, 1fr))`;
  };
  const getResponsiveWidth = () => {
    if (typeof window !== "undefined") {
      const width = window.innerWidth;

      if (width <= 425) {
        // Mobile breakpoint
        return "100%";
      } else if (width > 425) {
        // Desktop
        return "80%";
      }
    }
    return "100%"; // fallback
  };
  return (
    <>
      {contestClosedPopup && (
        <ContestClosePopup
          setPopup={setContestClosedPopup}
          backgroundColor={contestDetails?.buttonColor}
          message={`Sorry, this contest isn’t 
open to participation now`}
        />
      )}
      {contestUpcomingPopup && (
        <ContestClosePopup
          setPopup={setContestUpcomingPopup}
          backgroundColor={contestDetails?.buttonColor}
          message={`Sorry, participation in this contest is not open at the moment. Stay tuned for updates!`}
          icon={comingSoon}
        />
      )}
      <div className={`flex flex-col h-[100%]  items-center z-[1] relative`}>
        <div className=" h-[100%] w-[100%]">
          <div className="w-[100%]  z-[1] flex flex-col justify-center items-center  text-center relative">
            {!_.isEmpty(contestDetails?.performanceData) && (
              <div className="absolute top-[-73px] w-full px-[20px]">
                {contestDetails?.performanceData?.fileType?.startsWith(
                  "video"
                ) ? (
                  <div className="h-[125px] rounded-[29px] bg-opacity-60 bg-white px-[20px] py-[8px] bg-gradient-to-r from-opacity-80 to-opacity-0 via-gray-232">
                    <ReferenceVideoPlayer
                      performanceData={contestDetails?.performanceData}
                    />
                  </div>
                ) : (
                  <div className="h-[125px] rounded-[29px] bg-opacity-60 bg-white px-[20px] py-[8px] bg-gradient-to-r from-opacity-80 to-opacity-0 via-gray-232">
                    <AudioPlayer
                      contestDetails={contestDetails}
                      isPlaying={isPlaying}
                      setIsplaying={setIsplaying}
                      audioElem={audioElem}
                    />
                  </div>
                )}
              </div>
            )}

            {contestDetails?.contestStatus !== "OPEN" && (
              <div
                className={`px-[10px] py-[6px] bg-[#F2FDF4] rounded-[8px] text-small-bold absolute ${
                  _.isEmpty(contestDetails?.performanceData)
                    ? "top-[-40px]"
                    : "top-[-117px]"
                }`}
              >
                {/* {contestDetails?.contestStatus == "OPEN" && (
                <div className="text-[#1F8D2A] flex items-center gap-[6px]">
                  <img src={conOpen} />
                  OPEN
                </div>
              )} */}
                {contestDetails?.contestStatus == "CLOSED" &&
                  !contestDetails?.winnerSelected && (
                    <div className="text-[#D3271C] flex items-center gap-[6px]">
                      <img src={conClosed} />
                      {details?.closedCampaign ? "CLOSED" : "JUDGING"}
                    </div>
                  )}
                {contestDetails?.contestStatus == "CLOSED" &&
                  contestDetails?.winnerSelected && (
                    <div className="text-[#EF6525] flex items-center gap-[6px]">
                      <img src={conWinner} />
                      RESULT
                    </div>
                  )}
              </div>
            )}

            {contestDetails?.contestStatus == "CLOSED" &&
              !contestDetails?.winnerSelected &&
              !details?.closedCampaign && (
                <p
                  className="text-small px-[25px]  max-w-[400px] text-[#B8B8B8] mt-[20px]"
                  style={{ color: contestDetails?.buttonColor }}
                >
                  The contest is now closed for judging.
                </p>
              )}

            {/* {(navigator.userAgent.includes("Instagram") ||
              navigator.userAgent.match(/FBAN|FBAV/i)) &&
              (!_.isEmpty(contestDetails?.performanceData) ? (
                <button
                  style={getDetailsViaWhatsappButton}
                  className="commonButton text-regular-bold  text-black absolute top-[-147px] flex items-center gap-[5px]"
                  onClick={sentDetailsToWhatsapp}
                >
                  <img src={whatsappIcon} />
                  Sent Contest Details
                </button>
              ) : (
                <button
                  style={getDetailsViaWhatsappButton}
                  className="commonButton text-regular-bold  text-black absolute top-[-70px] flex items-center gap-[5px]"
                  onClick={sentDetailsToWhatsapp}
                >
                  <img src={whatsappIcon} />
                  Sent Contest Details
                </button>
              ))} */}
            <>
              {contestParticipationTimeOut >= 0 ? (
                <>
                  {(campaignClosed || campaignEntryClosed || contestClosed) && (
                    <>
                      {/* <button
                        style={participateButtonStyle}
                        className="closedContest commonButton text-black"
                        onClick={() => setContestClosedPopup(true)}
                      >
                        <span className="text-regular-bold">
                          {contestDetails?.buttonText}
                        </span>
                      </button> */}
                    </>
                  )}
                  {!campaignClosed &&
                    !campaignEntryClosed &&
                    !contestClosed &&
                    (participateLoading ? (
                      <button
                        style={participateButtonStyle}
                        className=" commonButton text-black mt-[20px]"
                      >
                        <span className="text-regular-bold">Loading</span>
                      </button>
                    ) : guestModeEnabled ? (
                      <button
                        style={participateButtonStyle}
                        id={`PB_${contestDetails?.contestId}`}
                        className="commonButton text-black mt-[20px] relative"
                        onClick={(e) => {
                          setPreviousLocation(window.location.pathname);
                          handleSignup(true);
                          handleUserTracking(e.currentTarget.id);
                        }}
                      >
                        <span className="text-regular-bold ">
                          {contestDetails?.buttonText}
                        </span>
                        <HelpingHand />
                      </button>
                    ) : (
                      <button
                        style={participateButtonStyle}
                        className="commonButton text-black mt-[20px] relative"
                        id={`PB_${contestDetails?.contestId}`}
                        onClick={(e) => {
                          setPreviousLocation(window.location.pathname);
                          handleParticipate();
                          handleUserTracking(e.currentTarget.id);
                        }}
                      >
                        <span className="text-regular-bold">
                          {contestDetails?.buttonText}
                        </span>
                        <HelpingHand />
                      </button>
                    ))}
                </>
              ) : (
                <>
                  {/* <button
                    style={participateButtonStyle}
                    className="closedContest commonButton text-black"
                    onClick={() => {
                      contestOpenTimeout > 0
                        ? setContestUpcomingPopup(true)
                        : setContestClosedPopup(true);
                    }}
                  >
                    <span className="text-regular-bold">
                      {contestDetails?.buttonText}
                    </span>
                  </button> */}
                </>
              )}
            </>
          </div>
          {/* <Banner/> */}
          <div className=" text-white ">
            {/* <div
            className="h-auto w-[100%] pb-[20px] bg-[transpanrent] flex justify-end px-[16px] hide-nav-on-scroll fixed z-[9]"
            id="navbar"
          >
            {campaignClosed && campaignEntryClosed && contestClosed && (
              <>
                <div
                  style={{ backgroundColor: contestDetails?.buttonColor }}
                  className="h-[54px] w-[185px] rounded-full flex items-center justify-center cursor-pointer "
                >
                  <span className="text-[17px] font-semibold flex items-center justify-center ">
                    Closed{" "}
                  </span>
                </div>
              </>
            )}
          </div> */}
            {/* <Header details={details} type="contest" /> */}
            <div className=" flex flex-col">
              {campaignType === "DA_PAID" && (
                <Dance
                  contestDetails={contestDetails}
                  isPlaying={isPlaying}
                  setIsplaying={setIsplaying}
                  audioElem={audioElem}
                  campaignClosed={campaignClosed}
                  contestClosed={contestClosed}
                />
              )}
              {campaignType === "MOV" && (
                <Movie
                  contestDetails={contestDetails}
                  isPlaying={isPlaying}
                  setIsplaying={setIsplaying}
                  audioElem={audioElem}
                  campaignClosed={campaignClosed}
                  contestClosed={contestClosed}
                />
              )}
              {campaignType === "HTL" && (
                <Hotel
                  contestDetails={contestDetails}
                  isPlaying={isPlaying}
                  setIsplaying={setIsplaying}
                  audioElem={audioElem}
                  campaignClosed={campaignClosed}
                  contestClosed={contestClosed}
                />
              )}
              {campaignType === "FBL" && (
                <Fifa
                  contestDetails={contestDetails}
                  isPlaying={isPlaying}
                  setIsplaying={setIsplaying}
                  audioElem={audioElem}
                  campaignClosed={campaignClosed}
                />
              )}

              <div>
                {/* <div className="relative  z-[1] px-[20px] pt-[10px]">
                  <p className="explainTxt">
                    {details &&
                      details.description &&
                      (showFullText === false
                        ? details?.description.slice(0, 70)
                        : details?.description)}

                    {details?.description?.length > 70 && (
                      <span
                        onClick={() => setShowFullText(!showFullText)}
                        className="whitespace-nowrap"
                      >
                        {" "}
                        {details &&
                          details.description &&
                          (showFullText === false ? "Details" : "Close")}{" "}
                        <img src={Bluearrow} alt="" />
                      </span>
                    )}
                  </p>
                </div> */}

                <div className="relative  z-[1] mt-[20px] mx-[auto] px-[20px]">
                  <div className="w-[100%] text-center flex flex-col items-center">
                    <p
                      className="text-large-medium mb-[12px] "
                      style={{ color: contestDetails?.buttonColor }}
                    >
                      {contestDetails?.contestName}
                    </p>
                    {contestDetails?.explanationDoc?.fileUrl && (
                      <div className={styles.explanationDoc}>
                        <a
                          href={contestDetails?.explanationDoc?.fileUrl}
                          target="_blank"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="14"
                            height="15"
                            viewBox="0 0 14 15"
                            fill="none"
                            className="h-[18px] w-[18px]"
                          >
                            <path
                              d="M10.3125 3.75H13.125L9.375 0V2.8125C9.375 3.32812 9.79688 3.75 10.3125 3.75Z"
                              fill="#B0B7BD"
                            />
                            <path
                              d="M10.7812 12.6562H1.875V13.125H10.7812C11.0391 13.125 11.25 12.9141 11.25 12.6562V12.1875C11.25 12.4453 11.0391 12.6562 10.7812 12.6562Z"
                              fill="#CAD1D8"
                            />
                            <path
                              d="M2.8125 0C2.29688 0 1.875 0.421875 1.875 0.9375V14.0625C1.875 14.5781 2.29688 15 2.8125 15H12.1875C12.7031 15 13.125 14.5781 13.125 14.0625V3.75L9.375 0H2.8125Z"
                              fill="#E2E5E7"
                            />
                            <path
                              d="M13.125 6.5625L10.3125 3.75H13.125V6.5625Z"
                              fill="#CAD1D8"
                            />
                            <path
                              d="M11.25 12.1875C11.25 12.4453 11.0391 12.6562 10.7812 12.6562H0.46875C0.210938 12.6562 0 12.4453 0 12.1875V7.5C0 7.24219 0.210938 7.03125 0.46875 7.03125H10.7812C11.0391 7.03125 11.25 7.24219 11.25 7.5V12.1875Z"
                              fill="#F15642"
                            />
                            <path
                              d="M2.04346 8.88131C2.04346 8.75756 2.14096 8.62256 2.29799 8.62256H3.16377C3.65127 8.62256 4.09002 8.94881 4.09002 9.57412C4.09002 10.1666 3.65127 10.4966 3.16377 10.4966H2.53799V10.9916C2.53799 11.1566 2.43299 11.2499 2.29799 11.2499C2.17424 11.2499 2.04346 11.1566 2.04346 10.9916V8.88131ZM2.53799 9.09459V10.0283H3.16377C3.41502 10.0283 3.61377 9.80662 3.61377 9.57412C3.61377 9.31209 3.41502 9.09459 3.16377 9.09459H2.53799Z"
                              fill="white"
                            />
                            <path
                              d="M4.82369 11.2498C4.69994 11.2498 4.56494 11.1823 4.56494 11.0178V8.88875C4.56494 8.75422 4.69994 8.65625 4.82369 8.65625H5.68197C7.39478 8.65625 7.35729 11.2498 5.71572 11.2498H4.82369ZM5.05994 9.11375V10.7928H5.68197C6.694 10.7928 6.739 9.11375 5.68197 9.11375H5.05994Z"
                              fill="white"
                            />
                            <path
                              d="M7.96541 9.14373V9.73951H8.92119C9.05619 9.73951 9.19119 9.87451 9.19119 10.0053C9.19119 10.129 9.05619 10.2303 8.92119 10.2303H7.96541V11.0173C7.96541 11.1486 7.87213 11.2494 7.74088 11.2494C7.57588 11.2494 7.4751 11.1486 7.4751 11.0173V8.88826C7.4751 8.75373 7.57635 8.65576 7.74088 8.65576H9.05666C9.22166 8.65576 9.31916 8.75373 9.31916 8.88826C9.31916 9.00826 9.22166 9.14326 9.05666 9.14326H7.96541V9.14373Z"
                              fill="white"
                            />
                          </svg>
                          <p className="text-smallest">
                            {contestDetails?.explanationDoc?.fileName}
                          </p>
                        </a>
                      </div>
                    )}
                    <HelpVIdeoCard contestDetails={contestDetails} />
                    {/* moved inside card */}
                    {/* <pre
                      className="text-small mb-[24px] px-[20px] cursor-pointer text-[#cdcdcd]"
                      onClick={viewMore}
                    >
                      {showFullText ? (
                        <>
                          {contestDetails?.description}
                          {contestDetails?.description?.length > 120 && (
                            <span
                              className=" whitespace-nowrap"
                              style={{ color: contestDetails?.buttonColor }}
                            >
                              {" "}
                              Read Less
                            </span>
                          )}
                        </>
                      ) : (
                        contestDetails?.description?.slice(0, 120)
                      )}
                      {!showFullText &&
                        contestDetails?.description?.length > 120 && (
                          <>
                            ...
                            <span
                              className=" whitespace-nowrap"
                              style={{ color: contestDetails?.buttonColor }}
                            >
                              {" "}
                              Read More
                            </span>
                          </>
                        )}
                    </pre> */}
                    {/* {!(new Date(contestDetails?.startDate) > new Date()) && (
                      <div className="rounded-[6px] overflow-hidden p-[2px] flex items-center justify-center w-[80%] mb-[20px] text-small">
                        <div
                          className={`px-[24px]  w-full ${
                            contestDetails?.contestStatus == "OPEN"
                              ? "bg-[#606060] rounded-[6px] py-[12px]"
                              : "opacity-60 bg-[#262626] rounded-l-[6px] py-[8px]"
                          }`}
                        >
                          Open
                        </div>
                        {!contestDetails?.noJudging && (
                          <div
                            className={`px-[24px] w-full  ${
                              contestDetails?.contestStatus == "CLOSED" &&
                              !contestDetails?.winnerSelected
                                ? "bg-[#606060] rounded-[6px] py-[12px]"
                                : "opacity-60 bg-[#262626] rounded-0 py-[8px]"
                            } `}
                          >
                            Judging
                          </div>
                        )}
                        <div
                          className={`px-[24px] w-full ${
                            contestDetails?.contestStatus == "CLOSED" &&
                            contestDetails?.winnerSelected
                              ? "bg-[#606060] rounded-[6px] py-[12px]"
                              : "opacity-60 bg-[#262626] rounded-r-[6px] py-[8px]"
                          }`}
                        >
                          Result
                        </div>
                      </div>
                    )} */}

                    {contestDetails?.contestStatus == "CLOSED" &&
                      contestDetails?.winnerSelected &&
                      (!_.isEmpty(winningArray?.crowdWinners) ||
                        !_.isEmpty(winningArray?.judgeWinners) ||
                        !_.isEmpty(winningArray?.specialWinners)) && (
                        <p className="text-small px-[24px] mb-[20px] max-w-[400px] text-[#B8B8B8]">
                          Congratulations to all the "{" "}
                          {contestDetails?.contestName}" contest winners. Our
                          talented participants have showcased exceptional
                          skill, creativity, and unwavering dedication, truly
                          embodying the spirit of champions in this competition.
                        </p>
                      )}
                    <div className="seperator" />
                  </div>
                  {contestDetails?.contestStatus == "OPEN" && (
                    <>
                      <div className="flex mt-[20px] items-center justify-center text-center">
                        {new Date(contestDetails?.startDate) > new Date() ? (
                          <>
                            {setContestParticipationTimeOut(-1)}
                            <CountDown
                              endTime={contestDetails?.startDate}
                              heading={`Participation will begin on ${formattedStartDate}`}
                              buttonColor={contestDetails?.buttonColor}
                              setContestParticipationTimeOut={
                                setContestOpenTimout
                              }
                              timeoutText="Participate Now"
                            />
                          </>
                        ) : (
                          <CountDown
                            endTime={contestDetails?.endDate}
                            heading={`Upload your ${
                              contestDetails?.fileType?.startsWith("video")
                                ? "videos"
                                : "entries"
                            } by <b
                            style="color:${contestDetails?.buttonColor}"
                            >${formattedjudgementStartDate}</b> and vote for your favourite ${
                              contestDetails?.fileType?.startsWith("video")
                                ? "videos"
                                : "entries"
                            } by <b
                            style="color:${contestDetails?.buttonColor}"
                            >${formattedjudgementCompleteDate}</b>`}
                            buttonColor={contestDetails?.buttonColor}
                            setContestParticipationTimeOut={
                              setContestParticipationTimeOut
                            }
                          />
                        )}
                      </div>
                      <div
                        className="grid grid-cols-4 gap-[10px] mb-[20px] mx-auto"
                        style={{
                          gridTemplateColumns: getGridTemplate(boxCount),
                          width: boxCount == 3 ? getResponsiveWidth() : "100%",
                        }}
                      >
                        {!_.isEmpty(details?.howToParticipate?.description) && (
                          <RulesBox
                            bgColor={contestDetails?.buttonColor}
                            heading="Contest Overview"
                            svg={worksIcon}
                          >
                            <pre className="text-small mb-[24px] text-[#cdcdcd]">
                              {contestDetails?.description}
                            </pre>
                          </RulesBox>
                        )}

                        {!_.isEmpty(contestDetails?.howItsWorks) && (
                          <RulesBox
                            heading="Steps to participate"
                            svg={stepsIcon}
                            bgColor={contestDetails?.buttonColor}
                          >
                            <div className="text-small mb-[32px]">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: `${contestDetails?.howItsWorks}`,
                                }}
                                className="flex flex-col gap-[12px] text-[#CDCDCD]"
                              />
                            </div>
                          </RulesBox>
                        )}
                        {!_.isEmpty(contestDetails?.contestRules) && (
                          <RulesBox
                            heading="Contest Rules"
                            svg={rulesIcon}
                            bgColor={contestDetails?.buttonColor}
                          >
                            <div className="text-small mb-[32px]">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: `${contestDetails?.contestRules}`,
                                }}
                                className="flex flex-col gap-[12px] text-[#CDCDCD]"
                              />
                              {isMobile && (
                                <div className="flex flex-col gap-[12px] text-[#CDCDCD] mt-[12px]">
                                  <p>
                                    <span
                                      style={{
                                        color: "rgb(250,197,28)",
                                        fontSize: "18px",
                                      }}
                                    >
                                      <strong>Apple Disclaimer</strong>
                                    </span>
                                  </p>
                                  <p>
                                    Any contests run on this application are not
                                    sponsored by Apple.
                                  </p>
                                </div>
                              )}
                            </div>
                          </RulesBox>
                        )}
                        {(details?.certificate ||
                          (contestDetails?.priceDescription &&
                            contestDetails?.priceDescription !== "<p></p>") ||
                          !_.isEmpty(contestDetails?.prizeObj)) && (
                          <RulesBox
                            bgColor={contestDetails?.buttonColor}
                            heading="Prize details"
                            svg={giftIcon}
                          >
                            <div className="text-small mb-[32px]">
                              <div class="flex flex-col gap-[12px] text-[#CDCDCD] star-bullet-point">
                                {contestDetails?.judgeWinnerAvailable && (
                                  <>
                                    <p>
                                      <strong>Contest prize</strong>
                                    </p>
                                    <ol>
                                      {contestDetails?.prizeObj
                                        ?.judgeWinner[1] && (
                                        <li>
                                          First prize:{" "}
                                          {
                                            contestDetails?.prizeObj
                                              ?.judgeWinner[1]?.prizeWorth
                                          }
                                        </li>
                                      )}
                                      {contestDetails?.prizeObj
                                        ?.judgeWinner[2] && (
                                        <li>
                                          Second prize:{" "}
                                          {
                                            contestDetails?.prizeObj
                                              ?.judgeWinner[2]?.prizeWorth
                                          }
                                        </li>
                                      )}
                                      {contestDetails?.prizeObj
                                        ?.judgeWinner[3] && (
                                        <li>
                                          Third prize:{" "}
                                          {
                                            contestDetails?.prizeObj
                                              ?.judgeWinner[3]?.prizeWorth
                                          }
                                        </li>
                                      )}
                                      {contestDetails?.prizeObj?.judgeWinner
                                        ?.general && (
                                        <p>
                                          {
                                            contestDetails?.prizeObj
                                              ?.judgeWinner?.general?.prizeWorth
                                          }
                                        </p>
                                      )}
                                    </ol>
                                    <p></p>
                                  </>
                                )}

                                {contestDetails?.crowdWinnerAvailable && (
                                  <>
                                    <p>
                                      <strong>Crowd Winner</strong>
                                    </p>
                                    <ol>
                                      {contestDetails?.prizeObj
                                        ?.crowdWinner[1] && (
                                        <li>
                                          First prize:{" "}
                                          {
                                            contestDetails?.prizeObj
                                              ?.crowdWinner[1]?.prizeWorth
                                          }
                                        </li>
                                      )}
                                      {contestDetails?.prizeObj
                                        ?.crowdWinner[2] && (
                                        <li>
                                          Second prize:{" "}
                                          {
                                            contestDetails?.prizeObj
                                              ?.crowdWinner[2]?.prizeWorth
                                          }
                                        </li>
                                      )}
                                      {contestDetails?.prizeObj
                                        ?.crowdWinner[3] && (
                                        <li>
                                          Third prize:{" "}
                                          {
                                            contestDetails?.prizeObj
                                              ?.crowdWinner[3]?.prizeWorth
                                          }
                                        </li>
                                      )}
                                      {contestDetails?.prizeObj?.crowdWinner
                                        ?.general && (
                                        <p>
                                          {
                                            contestDetails?.prizeObj
                                              ?.crowdWinner?.general?.prizeWorth
                                          }
                                        </p>
                                      )}
                                    </ol>
                                    <p></p>
                                  </>
                                )}
                                {contestDetails?.specialWinnerAvailable && (
                                  <>
                                    <p>
                                      <strong>Special Winner</strong>
                                    </p>

                                    {contestDetails?.prizeObj?.specialWinner
                                      ?.general && (
                                      <p>
                                        {
                                          contestDetails?.prizeObj
                                            ?.specialWinner?.general?.prizeWorth
                                        }
                                      </p>
                                    )}
                                    <p></p>
                                  </>
                                )}

                                {details?.certificate && (
                                  <>
                                    <p>
                                      <strong>Certificate</strong>
                                    </p>
                                    <p>E-certificate for all contestants</p>
                                    <p></p>
                                  </>
                                )}
                                <p></p>
                              </div>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: `${contestDetails?.priceDescription}`,
                                }}
                                className="flex flex-col gap-[12px] text-[#CDCDCD] star-bullet-point"
                              />
                            </div>
                          </RulesBox>
                        )}
                      </div>
                      {/* <div className="seperator my-[20px]" /> */}
                      {/* <Accordian
                        summary="Prize details"
                        buttonColor={contestDetails?.buttonColor}
                      >
                        <div className="text-small mb-[32px]">
                          <div class="flex flex-col gap-[12px] text-[#CDCDCD] star-bullet-point">
                            {contestDetails?.judgeWinnerAvailable && (
                              <>
                                <p>
                                  <strong>Contest prize</strong>
                                </p>
                                <ol>
                                  {contestDetails?.prizeObj?.judgeWinner[1] && (
                                    <li>
                                      First prize:{" "}
                                      {
                                        contestDetails?.prizeObj?.judgeWinner[1]
                                          ?.prizeWorth
                                      }
                                    </li>
                                  )}
                                  {contestDetails?.prizeObj?.judgeWinner[2] && (
                                    <li>
                                      Second prize:{" "}
                                      {
                                        contestDetails?.prizeObj?.judgeWinner[2]
                                          ?.prizeWorth
                                      }
                                    </li>
                                  )}
                                  {contestDetails?.prizeObj?.judgeWinner[3] && (
                                    <li>
                                      Third prize:{" "}
                                      {
                                        contestDetails?.prizeObj?.judgeWinner[3]
                                          ?.prizeWorth
                                      }
                                    </li>
                                  )}
                                  {contestDetails?.prizeObj?.judgeWinner
                                    ?.general && (
                                    <p>
                                      {
                                        contestDetails?.prizeObj?.judgeWinner
                                          ?.general?.prizeWorth
                                      }
                                    </p>
                                  )}
                                </ol>
                                <p></p>
                              </>
                            )}

                            {contestDetails?.crowdWinnerAvailable && (
                              <>
                                <p>
                                  <strong>Crowd Winner</strong>
                                </p>
                                <ol>
                                  {contestDetails?.prizeObj?.crowdWinner[1] && (
                                    <li>
                                      First prize:{" "}
                                      {
                                        contestDetails?.prizeObj?.crowdWinner[1]
                                          ?.prizeWorth
                                      }
                                    </li>
                                  )}
                                  {contestDetails?.prizeObj?.crowdWinner[2] && (
                                    <li>
                                      Second prize:{" "}
                                      {
                                        contestDetails?.prizeObj?.crowdWinner[2]
                                          ?.prizeWorth
                                      }
                                    </li>
                                  )}
                                  {contestDetails?.prizeObj?.crowdWinner[3] && (
                                    <li>
                                      Third prize:{" "}
                                      {
                                        contestDetails?.prizeObj?.crowdWinner[3]
                                          ?.prizeWorth
                                      }
                                    </li>
                                  )}
                                  {contestDetails?.prizeObj?.crowdWinner
                                    ?.general && (
                                    <p>
                                      {
                                        contestDetails?.prizeObj?.crowdWinner
                                          ?.general?.prizeWorth
                                      }
                                    </p>
                                  )}
                                </ol>
                                <p></p>
                              </>
                            )}
                            {contestDetails?.specialWinnerAvailable && (
                              <>
                                <p>
                                  <strong>Special Winner</strong>
                                </p>

                                {contestDetails?.prizeObj?.specialWinner
                                  ?.general && (
                                  <p>
                                    {
                                      contestDetails?.prizeObj?.specialWinner
                                        ?.general?.prizeWorth
                                    }
                                  </p>
                                )}
                                <p></p>
                              </>
                            )}

                            {details?.certificate && (
                              <>
                                <p>
                                  <strong>Certificate</strong>
                                </p>
                                <p>E-certificate for all contestants</p>
                                <p></p>
                              </>
                            )}
                            <p></p>
                          </div>
                          <div
                            dangerouslySetInnerHTML={{
                              __html: `${contestDetails?.priceDescription}`,
                            }}
                            className="flex flex-col gap-[12px] text-[#CDCDCD] star-bullet-point"
                          />
                        </div>
                      </Accordian>
                      <div className="seperator " />
                      <Accordian
                        summary="How this contest works ?"
                        buttonColor={contestDetails?.buttonColor}
                      >
                        <div
                          className=" text-small mb-[32px] star-bullet-point text-[#CDCDCD]"
                          // style={{ color: contestDetails?.buttonColor }}
                          dangerouslySetInnerHTML={{
                            __html: `${details?.howToParticipate?.description}`,
                          }}
                        />
                      </Accordian>
                      <div className="seperator " />
                      <Accordian
                        summary="Steps to participate"
                        buttonColor={contestDetails?.buttonColor}
                      >
                        <div className="text-small mb-[32px]">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: `${contestDetails?.howItsWorks}`,
                            }}
                            className="flex flex-col gap-[12px] text-[#CDCDCD]"
                          />
                        </div>
                      </Accordian>
                      <div className="seperator " />
                      {!_.isEmpty(contestDetails?.contestRules) && (
                        <>
                          <Accordian
                            summary="Contest Rules"
                            buttonColor={contestDetails?.buttonColor}
                          >
                            <div className="text-small mb-[32px]">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: `${contestDetails?.contestRules}`,
                                }}
                                className="flex flex-col gap-[12px] text-[#CDCDCD]"
                              />
                            </div>
                          </Accordian>
                        </>
                      )} */}
                    </>
                  )}
                  {contestDetails?.contestStatus == "CLOSED" &&
                    !contestDetails?.winnerSelected && (
                      <>
                        {contestDetails?.judgementText ? (
                          <Accordian
                            summary="Judging"
                            buttonColor={contestDetails?.buttonColor}
                          >
                            <div
                              className=" text-small mb-[32px] star-bullet-point text-[#CDCDCD] mt-[20px]"
                              // style={{ color: contestDetails?.buttonColor }}
                              dangerouslySetInnerHTML={{
                                __html: `${contestDetails?.judgementText}`,
                              }}
                            />
                          </Accordian>
                        ) : (
                          !details?.closedCampaign && (
                            <>
                              <p className="text-regular-medium my-[22px] ">
                                Judging
                              </p>
                              <ul className=" text-small mb-[24px] list-disc ml-[20px] ">
                                <li className="mb-[20px]">
                                  <strong>Contest Details:</strong> The winners
                                  are selected based on the overall score based
                                  on the cumulative votes of the jury and the
                                  crowd.
                                </li>
                                <li className="mb-[20px]">
                                  <strong> Judging period:</strong>{" "}
                                  {formattedjudgementStartDate || ""} to{" "}
                                  {formattedjudgementCompleteDate || ""}
                                </li>
                                <li className="mb-[20px]">
                                  Judges review entries and provide feedback
                                  during this period.
                                </li>
                                <li className="mb-[20px]">
                                  <strong> Judge Winning Category:</strong>{" "}
                                  Judges evaluate entries based on their
                                  preferences and expertise.
                                </li>
                                <li className="mb-[20px]">
                                  <strong>Crowd Winning Category:</strong>{" "}
                                  Winner selected based on the highest number of
                                  votes from the online community.
                                </li>
                                <li className="mb-[20px]">
                                  Winners will be revealed on{" "}
                                  <strong>
                                    {formattedwinnerAnounceDate || ""}.
                                  </strong>
                                </li>
                                <li>
                                  Both judge and crowd results will be disclosed
                                  simultaneously.
                                </li>
                              </ul>
                            </>
                          )
                        )}
                      </>
                    )}
                  {contestDetails?.contestStatus == "CLOSED" &&
                    contestDetails?.winnerSelected && (
                      <>
                        <Winners
                          details={details}
                          contestDetails={contestDetails}
                          setWinningArray={setWinningArray}
                        />
                      </>
                    )}
                  <div>
                    <div className="seperator" />

                    {/* <ShareInContest copyText={window.location.href} /> */}
                  </div>
                  {/* <div className="mb-[18px]">
                    <div className="flex ">
                      <div className="basis-1/3">
                        <p className="text-[#FF8165] text-regular whitespace-nowrap mb-[16px]">
                          Age limit
                        </p>
                        <p className="text-small">{contestDetails?.ageGroup}</p>
                      </div>
                      <div className="basis-2/3 mb-[18px]">
                        <p className="text-[#FF8165] text-regular whitespace-nowrap mb-[16px]">
                          Prize details
                        </p>
                        <p className="text-small">
                          {contestDetails?.priceDescription}
                        </p>
                      </div>
                    </div>
                    <p className="cursor-pointer text-[#0F6ABE] inline-block text-small">
                      View more details
                      <img
                        className=" inline-block ml-[5px]"
                        src={Bluearrow}
                        alt=""
                      />
                    </p>
                  </div> */}
                  {/* <div className="detailsBackground py-[12px] px-[16px] flex justify-center">
                    <img
                      className="inline-block  w-[13px] h-[13px]"
                      src={Star}
                      alt=""
                    />
                    <p className="explainTxt   inline-block">
                      {contestDetails?.entryFee?.fee &&
                        (showFullPrize === false ? (
                          <div
                            dangerouslySetInnerHTML={createMarkup(
                              contestDetails?.contestGifts
                            )}
                            className="text_Ell explainTxt"
                          />
                        ) : (
                          contestDetails?.entryFee?.fee
                        ))}

                      <span
                        onClick={() => setShowDetails(true)}
                        className="whitespace-nowrap"
                      >
                        {" "}
                        {contestDetails?.entryFee?.fee &&
                          (showFullPrize === false ? "Details" : "Close")}{" "}
                        <img src={Bluearrow} alt="" />
                      </span>
                    </p>
                  </div> */}
                </div>
              </div>

              {/* <p className="contest-card-participants px-[16px] text-[17px]">
              {contestDetails?.participantsCounter === 1
                ? contestDetails?.participantsCounter + ' Participant'
                : contestDetails?.participantsCounter + ' Participants'}{' '}
            </p> */}
              {/* {contestDetails?.mainSponser &&
              <div className="mt-[30px]">
                <span className="text-[21px]">Sponsors</span>
                <div className="flex mt-[20px] text-[16px] overflow-hidden overflow-x-auto gap-[10px] ">
                  {contestDetails?.mainSponser?.map((sponser) => {
                    return (
                      <>
                        <div
                          className=" h-[138px] flex flex-col items-center shrink-0 cursor-pointer"
                          onClick={() => handleSponsors(sponser)}
                        >
                          <img
                            src={sponser.logo}
                            alt=""
                            className="w-[100px] h-[100px] rounded-[8px] object-cover"
                          />
                          <span className="mt-[16px]">{sponser.name}</span>
                        </div>
                      </>
                    )
                  })}
                </div>
              </div>} */}
            </div>
            {/* View participation rules */}
            {/* <div className="h-[100%] bg-black">
            {participate && <HowToParticipate participate={participate} setParticipate={setParticipate} />}
          </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default Contest;
